import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { createVinculoComercial, updateVinculoComercial, deleteVinculoComercial } from '../../api/client'
import { mensajeError } from './comercialLogica'
import ComercialChip from './ComercialChip'
import ComercialSelectorOrganizacion from './ComercialSelectorOrganizacion'

const entrada = 'w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-200'

// A contact card's Organizaciones tab: where they work, each with its one
// current cargo (no dates, no history). Link another organization (never one
// already linked: one link per organization), change a cargo, or unlink -- which
// deletes the link and keeps the contact. An archived contact takes no new link.
//   c: the contact's card (vinculos: all its links); onCambio(): reload the card
export default function ComercialVinculosContacto({ c, abrir, puedeEditar, onCambio }) {
  const { t } = useTranslation('comercial')
  const [nuevo, setNuevo] = useState(null)            // { organizacion_id, cargo } while linking
  const [editando, setEditando] = useState(null)      // { id, cargo }
  const [ocupado, setOcupado] = useState(false)
  const [error, setError] = useState('')

  const hacer = async (llamar) => {
    setOcupado(true)
    setError('')
    try {
      await llamar()
      setNuevo(null)
      setEditando(null)
      onCambio()
    } catch (err) {
      setError(mensajeError(err, t, t('catalogo.fallo')))
    } finally {
      setOcupado(false)
    }
  }
  const vincular = () => hacer(() => createVinculoComercial(c.id, { organizacion_id: nuevo.organizacion_id, cargo: nuevo.cargo }))
  const guardarCargo = () => hacer(() => updateVinculoComercial(editando.id, { cargo: editando.cargo }))
  const desvincular = (v) => {
    if (!window.confirm(t('vinculos.desvincularConfirm', { contacto: c.nombre_completo, organizacion: v.organizacion.nombre_comercial }))) return
    hacer(() => deleteVinculoComercial(v.id))
  }
  const editable = puedeEditar && !c.archivado

  return (
    <div className="space-y-3">
      {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
      {!c.vinculos.length && !nuevo && <p className="text-sm text-gray-400">{t('fichaContacto.sinOrganizaciones')}</p>}
      <ul className="space-y-2">
        {c.vinculos.map(v => (
          <li key={v.id} className="rounded-lg border border-gray-100 bg-white px-3 py-2">
            <div className="flex flex-wrap items-center gap-1.5">
              <button type="button" onClick={() => abrir('org', v.organizacion_id)}
                className={`text-sm text-left hover:underline ${v.organizacion.archivada ? 'text-gray-400' : 'text-gray-900'}`}>
                {v.ruta}
              </button>
              {v.organizacion.archivada && <ComercialChip variante="archivado">{t('chips.archivada')}</ComercialChip>}
              {!v.activo && <ComercialChip variante="inactivo">{t('chips.inactivo')}</ComercialChip>}
            </div>
            {editando?.id === v.id ? (
              <div className="mt-2 flex flex-wrap items-center gap-2">
                <input autoFocus value={editando.cargo} onChange={e => setEditando({ ...editando, cargo: e.target.value })}
                  onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); guardarCargo() } }}
                  placeholder={t('vinculos.cargoPlaceholder')} aria-label={t('camposContacto.cargo')} className={`${entrada} flex-1 min-w-[12rem]`} />
                <button type="button" onClick={guardarCargo} disabled={ocupado}
                  className="px-3 py-1.5 rounded-lg text-xs font-medium bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-40">
                  {t('catalogo.guardar')}
                </button>
                <button type="button" onClick={() => setEditando(null)} className="px-3 py-1.5 rounded-lg text-xs text-gray-600 hover:bg-gray-50">
                  {t('catalogo.cancelar')}
                </button>
              </div>
            ) : (
              <div className="mt-0.5 flex flex-wrap items-center justify-between gap-2">
                <span className={`text-xs ${v.cargo ? 'text-gray-600' : 'text-gray-400'}`}>{v.cargo || t('contactosOrg.sinCargo')}</span>
                {puedeEditar && (
                  <span className="flex items-center gap-3 text-xs">
                    {!c.archivado && !v.organizacion.archivada && (
                      <button type="button" onClick={() => { setNuevo(null); setEditando({ id: v.id, cargo: v.cargo || '' }) }}
                        disabled={ocupado} className="text-gray-600 underline hover:text-gray-900">
                        {t('vinculos.cambiarCargo')}
                      </button>
                    )}
                    <button type="button" onClick={() => desvincular(v)} disabled={ocupado} className="text-red-600 underline hover:text-red-700">
                      {t('vinculos.desvincular')}
                    </button>
                  </span>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>

      {editable && (nuevo ? (
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3 space-y-2">
          <ComercialSelectorOrganizacion value={nuevo.organizacion_id} onChange={x => setNuevo({ ...nuevo, organizacion_id: x })}
            excluirIds={c.vinculos.map(v => v.organizacion_id)} aria-label={t('camposContacto.organizaciones')} />
          <input value={nuevo.cargo} onChange={e => setNuevo({ ...nuevo, cargo: e.target.value })}
            placeholder={t('vinculos.cargoPlaceholder')} aria-label={t('camposContacto.cargo')} className={entrada} />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => setNuevo(null)} className="px-3 py-1.5 rounded-lg text-xs text-gray-600 hover:bg-white">
              {t('catalogo.cancelar')}
            </button>
            <button type="button" onClick={vincular} disabled={ocupado || !nuevo.organizacion_id}
              className="px-3 py-1.5 rounded-lg text-xs font-medium bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-40">
              {t('vinculos.vincularBoton')}
            </button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => { setEditando(null); setNuevo({ organizacion_id: null, cargo: '' }) }}
          className="px-3 py-1.5 rounded-lg text-xs font-medium border border-gray-200 text-gray-700 hover:bg-gray-50">
          {t('vinculos.vincular')}
        </button>
      ))}
      {puedeEditar && c.archivado && <p className="text-xs text-gray-400">{t('vinculos.archivadoNota')}</p>}
    </div>
  )
}
